<!--Link title button-->

<button class="p-0 m-0 border-0 flex items-center gap-1.5 group">
  <span
    class="group-hover:text-primary text-base font-normal leading-snug whitespace-nowrap"
    [class.text-primary]="menuState"
  >
    {{ label }}
  </span>
  <span>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="black" d="M11.7377 6.20416C11.7119 6.14349 11.6684 6.09173 11.6128 6.0554C11.5572 6.01907 11.492 5.9998 11.4253 6H4.67005C4.60336 5.9998 4.53811 6.01907 4.48251 6.0554C4.42691 6.09173 4.38346 6.14349 4.35762 6.20416C4.33328 6.26572 4.32711 6.33283 4.33981 6.39772C4.35251 6.4626 4.38357 6.52261 4.42939 6.5708L7.80701 9.90396C7.87157 9.96556 7.95786 10 8.04766 10C8.13747 10 8.22376 9.96556 8.28832 9.90396L11.6659 6.5708C11.7117 6.52261 11.7428 6.4626 11.7555 6.39772C11.7682 6.33283 11.762 6.26572 11.7377 6.20416V6.20416Z"></path>
    </svg>
  </span>
</button>

<div
  class="absolute pt-2.5 z-50 transition-all"
  [ngClass]="{
    'opacity-0 -translate-y-[5px] pointer-events-none': !menuState,
    'opacity-100 translate-y-0 pointer-events-auto': menuState
  }"
>
  <div
    class="bg-white rounded-lg shadow flex-col justify-start items-start flex"
  >
    <div
      *ngFor="let link of links"
      class="last:border-0 w-full pl-3.5 pr-[60px] py-2 border-[1px] border-b border-t-0 border-x-0 border-solid border-gray-200 justify-start items-center gap-2 inline-flex"
    >
      <a
        [href]="generateLink(link.link, link.queryParams)"
        target="_blank"
        rel="noreferrer"
        class="text-center text-slate-950 text-sm font-normal leading-tight whitespace-nowrap inline-flex items-center"
      >
        {{ link.name }}
        @if (link.new) {
          <ra-label-new></ra-label-new>
        }
      </a>
<!--      @if (link.reachGoal) {-->
<!--      <a-->
<!--        [routerLink]="link.link"-->
<!--        [queryParams]="link.queryParams"-->
<!--        (click)="menuState = false"-->
<!--        metrikaGoal-->
<!--        [goalName]="link.reachGoal"-->
<!--        class="text-center text-slate-950 text-sm font-normal leading-tight whitespace-nowrap inline-flex items-center"-->
<!--        >-->
<!--        {{ link.name }}-->
<!--        @if (link.new) {-->
<!--          <ra-label-new></ra-label-new>-->
<!--        }-->
<!--      </a>-->
<!--      } @else {-->
<!--      <a-->
<!--        [routerLink]="link.link"-->
<!--        [queryParams]="link.queryParams"-->
<!--        (click)="menuState = false"-->
<!--        class="text-center text-slate-950 text-sm font-normal leading-tight whitespace-nowrap inline-flex items-center"-->
<!--        >-->
<!--        {{ link.name }}-->
<!--        @if (link.new) {-->
<!--          <ra-label-new></ra-label-new>-->
<!--        }-->
<!--      </a>-->
<!--      }-->
    </div>
  </div>
</div>


